import React from 'react';

const SectionHeading = ({ heading, subHeading, icon, additionalClasses, mainHeadingClass = 'c_dark', subHeadingClass = 'c-blue' }) => {
    return (
        <div className={`section-heading ${additionalClasses}`}>
            <div className={`main-heading `}>
                <h1>{heading}</h1>
            </div>
            <div className={`main-heading ${mainHeadingClass}`}>
                <h5>{subHeading}</h5>
            </div>
        </div>
    );
};

export default SectionHeading;
